    
    <div class="ui-g ui-fluid card card-w-title">
      <div class="ui-g-12" style="color: #20417b;font-size:18px;">
        {{'searchBox.search' | translate}}
      </div>
      <div class="ui-g-12">
        <div class="ui-g-9">
          <input pInputText [placeholder]="searchPlaceholder" type="text" 
                 [(ngModel)]="searchText" style="height: 40px;"
                 (keyup.enter)="this.onFind.emit(this.searchText);"/>
        </div>
        <div class="ui-g-3" >
          
          <button pButton type="button" class="k-generic-btn" label="{{'searchBox.find' | translate }}"
                  (click)="onFind.emit(searchText);"></button>
        </div>
      </div>
      <div class="ui-g-12" style="text-align: right;">
        <div class="ui-g-6"></div>
        <div class="ui-g-3">
          <button pButton type="button" class="k-generic-btn" label="{{'searchBox.find_advanced' | translate }}"
                  (click)="advancedSearch()"></button>
        </div>
        
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/searchBox/searchBox.component.ts.SearchBoxComponent.html